module.exports = __webpack_public_path__ + "assets/160306aae5938e85683bc0a64fb26fb1.png";